import { z } from 'zod';

import { FileSchema } from '../../types/File.schema';

const addressmaps = z
    .array(
        z.object({
            type: z.literal('pplPlatform'),
            file: z.union([FileSchema, FileSchema.shape.id]),
        }),
    )
    .default([]);

export const controller = z
    .object({
        addressmaps,
    })
    .default({});
